import React, { PropsWithChildren } from "react";
import cx from "classnames";
import { focusStyle } from "../../../../constants";
import { dataTestIds } from "data-testids";

interface Props {
  to: string;
}

const FooterLink = ({ to, children }: PropsWithChildren<Props>) => {
  const footerLinkClassName = cx(
    "hover:underline active:text-grey-medium-3",
    focusStyle
  );

  return (
    <a
      href={to}
      className={footerLinkClassName}
      target="_blank"
      rel="noreferrer"
      data-testid={dataTestIds.componentLibrary["Organisms.Footer.footerLinks"]}
    >
      {children}
    </a>
  );
};

export default FooterLink;
